module.exports = __webpack_public_path__ + "img/img_bed_app_2_en.6c430ed1.png";